import React from 'react'
import PropTypes from 'prop-types'
import styles from './style.module.scss'
import MyImage from '../myImage'
import DetailShape from 'assets/images/detail-shape.png'
import BreadcrumbNav from '../breadcrumbNav'

function DriverDetail({ driverData }) {
  const { data } = driverData
  return (
    <>
      <div className="px-2 pt-4">
        <BreadcrumbNav />
      </div>
      <div className={`${styles.driverwrapper}`}>
        <div className={`${styles.driverLeft}`} style={{ backgroundImage: `url(${DetailShape.src})` }}>
          <MyImage src={data?.oDriver?.sImgUrl} height={442} width={441} className={`${styles.driverImage}`} alt="drivre" />
        </div>
        <div className={`${styles.driverRight} d-lg-block d-none`}>
          <div className={`${styles.driverDetail}`}>
            <span>Team</span>
            {data?.aTeams?.[0]?.sName}
          </div>
          <div className={`${styles.driverDetail}`}>
            <span>Nationality</span>
            {data?.oDriver?.sNationality}
          </div>
          <div className={`${styles.driverDetail}`}>
            <span>Podiums</span>
            {data?.nPodiums}
          </div>
          <div className={`${styles.driverDetail}`}>
            <span>Grands Prix entered</span>
            {data?.nGrandPrixEntered}
          </div>
          <div className={`${styles.driverDetail}`}>
            <span>World Championships</span>
            {data?.nWorldChampionshipsWins}
          </div>
          <div className={`${styles.driverDetail}`}>
            <span>Highest race finish</span>
            {data?.sHighestRaceFinish}
          </div>
          <div className={`${styles.driverDetail}`}>
            <span>Highest grid position</span>
            {data?.nHighestGridPosition}
          </div>
          <div className={`${styles.driverDetail}`}>
            <span>Date of birth</span>
            {data?.oDriver?.sDOB}
          </div>
          <div className={`${styles.driverDetail}`}>
            <span>Place of birth</span>
            {data?.sPlaceOfBirth}
          </div>
        </div>
      </div>
      <div className={`${styles.driverContent}`}>
        <div className={`${styles.driverRank}`}>
          <span>{data?.oDriver?.nPermanentNumber}</span>
          <MyImage src={data?.oDriver?.sCountryFlag} alt={data?.oDriver?.sNationality || 'Country Flag'} height={48} width={76} />
        </div>
        <h5 className={`${styles.driverName}`}>
          {data?.oDriver?.sName} {data?.oDriver?.sFamilyName}
        </h5>
        <div className={`${styles.driverRight} d-lg-none d-block`}>
          <div className={`${styles.driverDetail}`}>
            <span>Team</span>
            {data?.aTeams?.[0]?.sName}
          </div>
          <div className={`${styles.driverDetail}`}>
            <span>Nationality</span>
            {data?.oDriver?.sNationality}
          </div>
          <div className={`${styles.driverDetail}`}>
            <span>Podiums</span>
            {data?.nPodiums}
          </div>
          <div className={`${styles.driverDetail}`}>
            <span>Grands Prix entered</span>
            {data?.nGrandPrixEntered}
          </div>
          <div className={`${styles.driverDetail}`}>
            <span>World Championships</span>
            {data?.nWorldChampionshipsWins}
          </div>
          <div className={`${styles.driverDetail}`}>
            <span>Highest race finish</span>
            {data?.sHighestRaceFinish}
          </div>
          <div className={`${styles.driverDetail}`}>
            <span>Highest grid position</span>
            {data?.nHighestGridPosition}
          </div>
          <div className={`${styles.driverDetail}`}>
            <span>Date of birth</span>
            {data?.oDriver?.sDOB}
          </div>
          <div className={`${styles.driverDetail}`}>
            <span>Place of birth</span>
            {data?.sPlaceOfBirth}
          </div>
        </div>
        <h6 className={`${styles.driverBiography}`}>Biography</h6>
        <div className={`${styles.driverMain}`}>
          <p>{data?.sBioGraphy}</p>
        </div>
      </div>
    </>
  )
}

DriverDetail.propTypes = {
  driverData: PropTypes.object
}

export default DriverDetail
